import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import ConsumerServiceIcon, { hasConsumerServiceIcon } from '../ConsumerServiceIcon/ConsumerServiceIcon';

function NRSelect({
  className,
  size,
  variant,
  error,
  required,
  disabled,
  id,
  label,
  value,
  onChange,
  options,
  helperText,
  color = 'secondary',
  selectClasses,
  sx,
  emptyValueLabel = 'None',
  showEmptyValue = true,
  displayEmpty = false,
  icon,
  sxProps,
  noBorder = false,
  showIcon = true,
  multiple = false,
  showCheckboxes = true
}) {
  // Render selected values for multiple select
  const renderSelectedValues = selected => {
    if (!multiple || !Array.isArray(selected)) return selected;

    const selectedLabels = selected
      .map(val => {
        const option = options.find(opt => opt.value === val);
        if (!option) return val;

        if (typeof option.renderValueLabel === 'string' || typeof option.renderValueLabel === 'number') return String(option.renderValueLabel);
        if (typeof option.text === 'string' || typeof option.text === 'number') return String(option.text);
        if (typeof option.label === 'string' || typeof option.label === 'number') return String(option.label);

        return val;
      })
      .filter(Boolean);

    return selectedLabels.join(', ');
  };

  return (
    <FormControl className={className} size={size} variant={variant} error={error} required={!!required} disabled={disabled} sx={sxProps}>
      {!!label && (
        <InputLabel id={`label-${id}`} color={color}>
          {label}
        </InputLabel>
      )}
      <Select
        multiple={multiple}
        labelId={`label-${id}`}
        id={`selectId-${id}`}
        value={value}
        onChange={e => onChange(e.target.value)}
        label={label}
        data-testid={'testIdSelect'}
        color={color}
        displayEmpty={displayEmpty}
        className={selectClasses}
        sx={{
          ...(noBorder && {
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            }
          }),
          ...sx
        }}
        {...(!!icon && { IconComponent: icon })}
        {...(multiple && { renderValue: renderSelectedValues })}
      >
        {!required && showEmptyValue && !multiple && (
          <MenuItem value={''} key={'empty-value'}>
            {emptyValueLabel}
          </MenuItem>
        )}
        {options &&
          options.map(({ value: optValue, label: optLabel, disabled: optDisabled }) => {
            const hasIcon = showIcon && hasConsumerServiceIcon(optValue);
            const isSelected = multiple && Array.isArray(value) ? value.indexOf(optValue) > -1 : value === optValue;

            return (
              <MenuItem value={optValue} key={optValue} data-testid={'select-option'} disabled={optDisabled}>
                {multiple && showCheckboxes && <Checkbox checked={isSelected} />}
                <Box display="flex" alignItems="center">
                  {hasIcon && <ConsumerServiceIcon className="select-icon" serviceName={optValue} />}
                  <Box ml={hasIcon ? 1 : 0} component="span">
                    {multiple ? <ListItemText primary={optLabel} /> : optLabel}
                  </Box>
                </Box>
              </MenuItem>
            );
          })}
      </Select>
      {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default NRSelect;
